import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';

const Reassignmodal = (props) => {
  // console.log('Reassignmodal: ', props)
  // const [crew, setCrew]
  const [state, setState] = React.useState({
    crew: props.crew,
    newCrew: {},
    item: props.item
  })

  // React.useEffect(() => {
  //   setState({...state, crwe: props.crew})
  // }, [])
  const crewNameAndForeman = (crew) => {
    // console.log('Get Label Option', crew)
    if (crew) {
      if (crew && crew.foremanName) {
        return crew.name + ' (' + crew.foremanName + ')'
      } else {
        return crew.name
      }
    } else {
      return ''
    }
  }

  const updateCrew = (id, val) => {
  // console.log('UPdate crew!!!!', id)
  // console.log(val)
    let newItem = props.item
    newItem.crew = val._id
    newItem.crewName = val.name
  // console.log('New Item w/ crew: ', newItem)
    setState({...state, newCrew: val, item: newItem})
  }

  const handleSave = () => {
  // console.log('Save this shit', state)
    props.saveAssignment(state)
  }

  const handleServiceChange = (type, date, item) => {
  // console.log('Date change', date)
  // console.log('i: ', item)
    item.scheduledDate = date
  // console.log('UPdated item', item)
    props.saveReschedule(item)
  }

  return (
    <TextField
    id="date"
    // label="Scheduled Date"
    type="date"
    value={moment(state.item.scheduledDate).format('YYYY-MM-DD') } // "2017-05-24"}
    // className={classes.textField}
    // variant="outlined"
    onChange={ e => handleServiceChange('scheduledDate', e.target.value, state.item) }
    InputLabelProps={{
      shrink: true,
    }}
  />
  )
}
export default Reassignmodal